/** Statuses treated as "active" on client dashboards and nav badges. */
export const ACTIVE_CLIENT_CYCLE_STATUSES = [
  'in-progress',
  'in_progress',
  'planned',
  'draft',
  'active',
  'pending_approval',
  'paused',
];

export function isActiveClientCycleStatus(status) {
  return ACTIVE_CLIENT_CYCLE_STATUSES.includes((status || '').toLowerCase());
}

export function filterActiveClientCycles(cycles = []) {
  return (cycles || []).filter((c) => isActiveClientCycleStatus(c.status));
}
